export const isDevelopment = process.env.NEXT_PUBLIC_ENV === 'development';
